import {
  PaymentOutcomeActions,
  PaymentOutcomeLayout,
} from "investment/PaymentOutcomeLayout";
import { useConfirmInvestmentPayment } from "hooks/useConfirmInvestmentPayment";

export default function InvestmentPaymentSuccessPage() {
  const payment = useConfirmInvestmentPayment({ redirectOnFailure: true });

  if (payment.phase === "loading") {
    return (
      <PaymentOutcomeLayout
        variant="loading"
        pageTitle="Confirming payment"
        title="Confirming your payment"
        description="Please wait while we verify your investment with Stripe…"
      />
    );
  }

  if (payment.phase === "error") {
    return (
      <PaymentOutcomeLayout
        variant="failed"
        pageTitle="Payment verification failed"
        title="Could not confirm payment"
        description={payment.message}
        primaryAction={
          <PaymentOutcomeActions
            campaignId={payment.projectId}
            amount={payment.amount}
            showRetry
          />
        }
      />
    );
  }

  if (payment.phase === "processing") {
    return (
      <PaymentOutcomeLayout
        variant="success"
        pageTitle="Payment processing"
        title="Payment processing"
        description={payment.message}
        primaryAction={
          <PaymentOutcomeActions
            campaignId={payment.projectId}
            amount={payment.amount}
          />
        }
      />
    );
  }

  return (
    <PaymentOutcomeLayout
      variant="success"
      pageTitle="Investment successful"
      title="Investment successful"
      description={payment.message}
      primaryAction={
        <PaymentOutcomeActions
          campaignId={payment.projectId}
          amount={payment.amount}
        />
      }
    />
  );
}
